import React, { useEffect } from "react";
import { Box, CssBaseline, Typography } from "@mui/material";
import { motion } from "framer-motion"

import Auth_Pic from "../../images/auth2.jpg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const imageVariant = {
  initial: { scale: 1.08 },
  animate: {
    scale: 1,
    transition: { duration: 1.8, ease: "easeOut" }
  }
};

const gradientVariant = {
  animate: {
    backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
    transition: {
      duration: 60,
      repeat: Infinity,
      ease: "linear"
    }
  }
};

const cardVariant = {
  initial: { opacity: 0, y: 40 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.6,
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

const chipVariant = {
  initial: { opacity: 0, y: 10 },
  animate: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.9 + i * 0.15,
      duration: 0.4
    }
  })
};

const AuthLayout = ({ children }) => {
  const { user } = useSelector((state) => state?.auth);
  const navigate = useNavigate();

  console.log('user log', user)

  useEffect(() => {
    if (user) {
      navigate('/dashboard')
    }
  }, [])

  return (
    <div>
      <div className="flex justify-center lg:justify-start lg:col-span-2">
        <div className="w-full lg:w-6/12 flex justify-center px-6 lg:px-24">
          {children}
        </div>
        {/* <div className="hidden lg:block fixed right-0 w-6/12 h-screen bg-primary">
            <div className="flex flex-col justify-between h-2/5">
                <Box className="ml-20 mt-20">
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                  >
                    <Typography>
                      <Typography
                      component={"span"}
                      display="inline"
                      variant="h5"
                      fontWeight="700"
                      color="white"
                      >
                      GET STARTED WITH{" "}
                      </Typography>
                      <Typography
                      component={"span"}
                      display="inline"
                      variant="h5"
                      fontWeight="700"
                      color="black"
                      >
                      SERVA
                      </Typography>
                    </Typography>
                  </motion.div>
                
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, delay: 0.2 }}
                  >
                    <Typography sx={{ color: "white", mt: 2 }}>
                      Here goes some information about Serva and a tagline <br></br>
                      that best describes the purpose of Serva
                    </Typography>
                  </motion.div>
                
                </Box>
                <motion.div
                  className="relative"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.4 }}
                >
                    <img
                        src={Dashboard_Peek}
                        alt="Dashboard Peek"
                        // style={{
                        //     borderTopLeftRadius: "25px",
                        // }}
                        className="absolute -right-10 left-10"
                    />
                </motion.div>
            </div>
        </div> */}

        <div className="hidden lg:block fixed right-0 w-6/12 h-screen  ">
          <div className="w-full h-full relative">



            {/* Image */}
            <motion.img
              src={Auth_Pic}
              alt=""
              className="w-full h-full object-cover"
              variants={imageVariant}
              initial="initial"
              animate="animate"
            />

            {/* Animated Gradient Overlay */}
            <motion.div
              variants={gradientVariant}
              animate="animate"
              className="absolute inset-0 bg-gradient-to-tr
      from-[#4B0000]/80 via-black/40 to-[#7a0000]/70
      bg-[length:300%_300%]"
            />

            {/* Glass Card */}
            <motion.div
              variants={cardVariant}
              initial="initial"
              animate="animate"
              className="absolute bottom-20 left-16
      backdrop-blur-xl bg-white/10
      border border-white/20
      rounded-2xl p-8 max-w-md text-white shadow-2xl"
            >
              <h2 className="text-2xl font-semibold leading-tight">
                POS Built for Modern Restaurants
              </h2>

              <p className="mt-3 text-sm text-white/80">
                Digital menus, fast checkout, live kitchen tracking, and complete inventory control.
              </p>

              <div className="mt-5 flex gap-3 flex-wrap">
                {["POS", "QR Menu", "Inventory"].map((item, i) => (
                  <motion.span
                    key={item}
                    custom={i}
                    variants={chipVariant}
                    initial="initial"
                    animate="animate"
                    className="px-3 py-1 bg-white/20 rounded-full text-xs backdrop-blur-md"
                  >
                    {item}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AuthLayout;